class TierAccessToBenefitGroupRemovedSystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.benefitName = systemNotificationPayloadData.benefit_name || "";
  }
}

export default TierAccessToBenefitGroupRemovedSystemNotificationPayload;
